<template>
<div class="d-flex" center middle style='width:100%;height:100%'>
  <van-loading size="24px">加载中...</van-loading>
</div>
</template>
<script>


export default {
  methods: {
    loadRoutes() {

    }
  },
  mounted() {
    this.$config.addRoutes = true;
    this.loadRoutes();
    if (this.$route.query["from"]) {
      this.$router.replace(this.$route.query["from"]);
    } else {
      this.$router.replace("/");
    }
  }
}
</script>
<style lang="less">

</style>
